import { Directive, HostBinding, input } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary';
export type ButtonShape = 'square' | 'default' | 'custom';

@Directive({
  selector: 'button[sharedCoreButton]',
})
export class ButtonDirective {
  readonly variant = input<ButtonVariant>('secondary');
  readonly shape = input<ButtonShape>('default');
  readonly disabled = input(false);

  variantClasses: Record<ButtonVariant, string> = {
    primary: 'bg-primary text-white',
    secondary: 'border border-theme-secondary-gray bg-white',
  };

  shapeClasses: Record<ButtonShape, string> = {
    square: 'px-2 py-2',
    default: 'px-4 py-3 gap-x-4',
    custom: '',
  };

  // the `disabled` input shadows the native property, so the button has to disable itself
  @HostBinding('disabled')
  get isDisabled() {
    return this.disabled();
  }

  @HostBinding('class')
  get class() {
    return `text-sm rounded-md font-semibold hover:brightness-90 h-fit gap-2 transition uppercase flex justify-center items-center ${this.shapeClasses[this.shape()]} ${!this.disabled() ? this.variantClasses[this.variant()] : '!cursor-not-allowed bg-gray-200 border-gray-200'}`;
  }
}
